<template>
  <span class="user__initials">
    <div v-b-tooltip.hover @click="showOffscreenMenu" :title="userName" class="logged-in-user mr-2">
      {{ userName | textInitials }}
    </div>
    <OffscreenMenu v-click-outside="hideOffscreenMenu" :userName="userName" :toggle="toggle"/>
    <div class="offscreen__menu__backdrop" v-if="toggle"></div>
  </span>
</template>

<script>
import OffscreenMenu from "./OffscreenMenu";
export default {
  data() {
    return {
      toggle: false,
      usernameUpdateTrigger: 0,
    }
  },
  components: {
    OffscreenMenu
  },
  methods: {
    hideOffscreenMenu() {
      this.toggle = false;
      $('body').removeClass('overflow-hidden');
    },
    showOffscreenMenu() {
      this.toggle = true;
      $('body').addClass('overflow-hidden');
    },
    handleUsernameUpdated() {
      this.usernameUpdateTrigger++;
    }
  },
  computed: {
    userName() {
      this.usernameUpdateTrigger;
      return localStorage.getItem("user");
    },
  },
  created() {
    this.$root.$on('usernameUpdated', this.handleUsernameUpdated);
  },
  beforeDestroy() {
    this.$root.$off('usernameUpdated', this.handleUsernameUpdated);
  },
};
</script>